<template>
  <div class="yx_zhucebox" :style="styles">
    <slot></slot>
    <div class="yx_zhuce">
      <h3>免费约课</h3>
      <input type="text" name="fc_subject" v-model="inpSubject" placeholder="科目" />
      <input type="text" name="fc_name" placeholder="姓名" v-model="inpName" />
      <input type="text" name="fc_phonetel" placeholder="手机号" maxlength="11" v-model="inpPhone" />
      <a @click="submit" class="yx_yuyuebtn">马上预约</a>
      <ul class="clearfix">
        <li @click="getZixun()" v-for="(item, index) in consultList" :key="index"><i></i><a>{{ item }}</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { cityFormInfo } from 'js/staticData.js'
export default {
  name: 'rightForm',
  data () {
    return {
      inpSubject: '',
      inpName: '',
      inpPhone: '',
      errName: '',
      errAge: '',
      errPhone: ''
    }
  },
  props: ['consultList', 'styles'],
  computed: {
    clearCheck () {
      return function (val) {
        if (val === '') {
          return false
        } else {
          return true
        }
      }
    }
  },
  methods: {
    submit () {
      window.open(`http://cmsdt.xdf.cn/formcollector.php?fc_formid=${cityFormInfo[this.$store.state.soukecityId].pcformId}&fc_subject=${this.inpSubject}&fc_name=${this.inpName}&fc_phonetel=${this.inpPhone}`)
    },
    getZixun () {
      const cityData = cityFormInfo[this.$store.state.soukecityId]
      if(cityData.otherZixun){
        cityData.otherZixun.done()
      }else if (cityData.zixun) {
        window.open(cityData.zixun)
      } else if (cityData.configId) {
        easemobim.bind({configId: cityData.configId, hide: true, visitor: {userNickname: this.$cookies.get('Fingerprint_xdf')}})
      } else if (cityData.tenantId) {
        easemobim.bind({tenantId: cityData.tenantId, hide: true, visitor: {userNickname: this.$cookies.get('Fingerprint_xdf')}})
      }
    }
  },
  watch: {
    inpAge (val) {
      if (isNaN(val) || val < 0) {
        this.errAge = '请填写大于0的整数年龄'
      } else {
        this.errAge = ''
      }
    },
    inpPhone (val) {
      if (val !== '' && !/^1[34578]\d{9}$/.test(val)) {
        this.errPhone = '请输入11位有效手机号'
      } else {
        this.errPhone = ''
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.yx_zhucebox
  position: absolute
  right: 8px
  top: 74px
  .yx_zhuce
    width: 252px
    height: 360px
    background: #eff2f4
    margin: -22px auto 0
    padding: 23px 20px
    box-sizing: border-box
    h3
      font-size: 18px
      color: $themeColor
      margin: 6px 0
    input
      width: 196px
      height: 28px
      border: 1px solid #fff
      line-height: 28px
      padding-left: 8px
      color: #333
      font-size: 14px
      margin-top: 13px
      &::-webkit-input-placeholder
        color: #c8c8c8
      &:hover
        border: 1px solid #8dd4c8
    .yx_yuyuebtn
      display: block
      width: 207px
      height: 36px
      text-align: center
      line-height: 36px
      background: $themeColor
      color: #FFFEFE
      font-size: 16px
      margin-top: 24px
      margin-left: 1px
      cursor: pointer
      &:hover
        background: #2db39b
    ul
      width: 228px
      border-top: 1px solid #afe6dd
      margin-top: 25px
      margin-left: -10px
      padding: 6px 0
      li
        float: left
        height: 18px
        min-width: 90px
        line-height: 18px
        padding: 0 8px
        border: 1px solid #80d1c4
        border-radius: 10px
        margin-top: 12px
        margin-left: 4px
        cursor: pointer
        i
          float: left
          width: 16px
          height: 12px
          background: url(http://file.xdf.cn/neworiental/images/yx_indexbg.png?20190410) no-repeat -25px -30px
          margin-top: 3px
          margin-right: 3px
        a
          float: left
          color: $themeColor
        &:hover
          background-color: $themeColor
          a
            color: #ffffff
          i
            float: left
            width: 16px
            height: 12px
            background: url(http://file.xdf.cn/neworiental/images/yx_indexbg.png?20190410) no-repeat -205px -109px
            margin-top: 3px
</style>



// WEBPACK FOOTER //
// src/common-components/Rightform.vue